import React from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Section from '../../Section';
import SectionWrapper from '../../SectionWrapper';
import { DataTable } from '../../Shared/DataTable';
import { getCustomComponents } from '../../Shared/DataTable/BaseTable.js';
import { SMARTForm } from '../../Shared/Forms';
import { getLangKey, LANGUAGE_KEYS } from '../../Shared/Constants/LanguageKeys';
import { useTranslation } from 'react-i18next';

const FORM_CONTEXT = 'PreviewService';

export default function ConfigurationDetailModal(props) {
    const { t } = useTranslation();

    const setStatusTranslatedContent = (rowData) => {
        return <>{t(getLangKey(LANGUAGE_KEYS.BLS_INTERNALLICENCECONFIG_VERSIONSTATUS_TITLE_KEY, rowData.Status))}</>;
    };

    const SECTION_NAMES = {
        LICENCECONFIGURATION: t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_CONTENT_MENU_SERVICECONFIGURATION),
        LICENCEAPPCONFIGURATION: t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_CONTENT_MENU_SERVICEAPPCONFIGURATION)
    };

    return (
        <Modal isOpen={props.isOpen} className={'modal-content ' + props.modalClassName}>
            <ModalHeader className={props.modalHeaderClassName} >{t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_MODAL_TITLE_CONFIGURATIONHEADER)}</ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        {t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TITLE_AGENCY_NAME)}
                    </Col>
                    <Col>
                        {t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TITLE_SERVICE_NAME)}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h4>{props.agencyName}</h4>
                    </Col>
                    <Col>
                        <h4>{props.licenceName}</h4>
                    </Col>
                </Row>
                <SMARTForm
                    titleClassName='theme-new'
                    formContext={FORM_CONTEXT}
                    submitCallback={null}
                    defaultSection={SECTION_NAMES.LICENCECONFIGURATION}
                    sectionNames={SECTION_NAMES}
                >
                    {({ sectionState, toggleSection }) => (
                        <React.Fragment>
                            <Row>
                                <Col className="body-content">
                                    <SectionWrapper
                                        type='1'
                                        tabs={SECTION_NAMES}
                                        sectionState={sectionState}
                                        toggleSection={toggleSection}
                                        toggleFlex={true}
                                    >
                                        <Section
                                            type={1}
                                            sectionState={sectionState}
                                            sectionName={SECTION_NAMES.LICENCECONFIGURATION}
                                            toggleSection={toggleSection}
                                        >
                                            <DataTable
                                                pageSize="5"
                                                minFilterChars='2'
                                                data={props.lcData}
                                                noResultsMessage={t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TEXT_NO_SERVICE_RESULT_MESSAGE)}
                                                components={getCustomComponents()}
                                                columns={
                                                    {
                                                        VersionNo: { title: t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TITLE_VERSION_NO), width: '30%', DBkey: 'Version' },
                                                        Status: { title: t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TITLE_STATUS), width: '25%', DBkey: 'Status', setContent: setStatusTranslatedContent },
                                                        CreatedBy: { title: t(LANGUAGE_KEYS.BLS_INTERNALAPPLICATIONDETAILS_TABLE_INFORMATION_CREATEDBY), width: '30%', DBkey: 'CreatedBy' },
                                                        CreatedDate: { title: t(LANGUAGE_KEYS.BLS_INTERNALLICENCECONFIG_TABLE_TITLE_CREATEDDATE), width: '30%', DBkey: 'CreatedDate', isDate: true }
                                                    }
                                                }
                                            />
                                        </Section>
                                        <Section
                                            type={1}
                                            sectionState={sectionState}
                                            sectionName={SECTION_NAMES.LICENCEAPPCONFIGURATION}
                                            toggleSection={toggleSection}
                                        >
                                            <DataTable
                                                pageSize="5"
                                                minFilterChars='2'
                                                data={props.lacData}
                                                noResultsMessage={t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TEXT_NO_SERVICE_RESULT_MESSAGE)}
                                                components={getCustomComponents()}
                                                columns={
                                                    {
                                                        VersionNo: { title: t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TITLE_VERSION_NO), width: '20%', DBkey: 'Version' },
                                                        Status: { title: t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TITLE_STATUS), width: '25%', DBkey: 'Status', setContent: setStatusTranslatedContent },
                                                        ApplicationType: { title: t(LANGUAGE_KEYS.BLS_INTERNALPREVIEWSERVICE_TABLE_TITLE_APPLICATION_TYPE), width: '20%', DBkey: 'ApplicationType' },
                                                        CreatedBy: { title: t(LANGUAGE_KEYS.BLS_INTERNALAPPLICATIONDETAILS_TABLE_INFORMATION_CREATEDBY), width: '20%', DBkey: 'CreatedBy' },
                                                        CreatedDate: { title: t(LANGUAGE_KEYS.BLS_INTERNALLICENCECONFIG_TABLE_TITLE_CREATEDDATE), width: '20%', DBkey: 'CreatedDate', isDate: true }
                                                    }
                                                }
                                            />
                                        </Section>
                                    </SectionWrapper>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}
                </SMARTForm>
            </ModalBody>
            <ModalFooter>
                {props.cancelCallback && <Button color="backward" size="sm" onClick={props.cancelCallback}>{props.cancelText}</Button>}
            </ModalFooter>
        </Modal>
    );
}
